(function() {
    'use strict';

    angular
        .module('dialysisApp')
        .factory('ModalitySearch', ModalitySearch);

    ModalitySearch.$inject = ['$resource'];

    function ModalitySearch($resource) {
        var resourceUrl =  'api/_search/modalities/:id';

        return $resource(resourceUrl, {}, {
            'query': { method: 'GET', isArray: true}
        });
    }
})();
